module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/308.f05f4ffa.png";